import React from "react";

export const RootContentContext = React.createContext<{
  width: number;
  height: number;
}>(undefined as any);
